export const businessTypes = [
  { value: "company", label: "法人" },
  { value: "self_employment", label: "個人事業主" },
];
